import React from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import { siteAccent } from '../styledComponents/variables/colors';

const NavLink = styled(Link)`
  text-decoration: none;
  color: black;
  font-family: sans-serif;
  border-bottom: 2px solid transparent;
  &:hover {
    color: ${siteAccent};
    border-bottom: 2px solid ${siteAccent};
  }
  transition: 0.2s;
`;

const activeLink = {
  color: siteAccent,
  borderBottom: `2px solid ${siteAccent}`,
};

export default ({ clickAction }) => [
  <NavLink key="articles" exact to="/" activeStyle={activeLink}>
    ARTICLES
  </NavLink>,
  <NavLink key="about" exact to="/about" activeStyle={activeLink}>
    ABOUT
  </NavLink>,
  <NavLink key="contact" exact to="/contact" activeStyle={activeLink}>
    CONTACT
  </NavLink>,
];



// WEBPACK FOOTER //
// ./src/components/Header/LinksList.js